import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nrgyblast-fr/htdocs/fr.nrgyblast.co/app/components/Comments.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nrgyblast-fr/htdocs/fr.nrgyblast.co/app/components/Header.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nrgyblast-fr/htdocs/fr.nrgyblast.co/app/components/SinglePostContent.js");
;
import(/* webpackMode: "eager" */ "/home/nrgyblast-fr/htdocs/fr.nrgyblast.co/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/nrgyblast-fr/htdocs/fr.nrgyblast.co/node_modules/next/dist/client/image-component.js");
